export enum ClassOptions {
    NURSERY = "Nursery",
    LKG = "LKG",
    UKG = "UKG",
    FIRST = "1st",
    SECOND = "2nd",
    THIRD = "3rd",
    FOURTH = "4th",
    FIFTH = "5th",
    SIXTH = "6th",
    SEVENTH = "7th",
    EIGHTH = "8th",
    NINTH = "9th",
    TENTH = "10th",
    ELEVENTH = "11th",
    TWELFTH = "12th"
}

export const CLASS_OPTIONS_ARRAY = Object.values(ClassOptions);

export function getClassRank(className: string): number {
    if (!className) return -100;

    // Extract base class name (e.g. "10th A" -> "10th")
    const baseName = className.trim().split(/\s+|-/)[0];

    // Find index in CLASS_OPTIONS_ARRAY
    const rank = CLASS_OPTIONS_ARRAY.findIndex(cls => cls.toLowerCase() === baseName.toLowerCase());

    return rank !== -1 ? rank : -100;
}
